// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// components
import {
    ImageHelperSite,
    LinkHelperSite,
} from 'components'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    EditBlockSite,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template805SiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
    onClickIsModalSite,
} from 'services'

// props
type TemplateBlock805SiteProps = {
    blockId: string
    content: Template805SiteSerializer | undefined
    contentArray?: Template805SiteSerializer[]
    isEditHovered: boolean
    isInComponent?: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentStyles?: any
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock805Site: React.FC<TemplateBlock805SiteProps> = React.memo(({
    blockId,
    content,
    contentArray,
    isEditHovered,
    isInComponent,
    mainParentId,
    object,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [stylesNew, setStylesNew] = useState<CustomCSSProperties | undefined>(applyStyles())

    useEffect(() => {
        setStylesNew(applyStyles())
    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])

    function applyStyles() {
        try {
            return getStylesNew(reduxModalSite, styles, stylesEdit)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock805Site',
                'applyStyles',
            ))
        }
    }

    function onLinkClick() {
        try {
            if (content && contentArray) {
                onClickIsModalSite(dispatch, reduxAuth, reduxModalSite, content, object, contentArray)
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock805Site',
                'onLinkClick',
            ))
        }
    }

    return (
        <LinkHelperSite
            id={blockId}
            action={object.action}
            className={`template-block-805${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
            onClick={onLinkClick}
            style={stylesNew}
            to={content?.absolute_site_url}
        >
            {content?.gif_image && !content?.gif_video && (
                <ImageHelperSite
                    alt=''
                    className={`t-805-image ${deviceType}`}
                    dominant_color={content?.get_dominant_color}
                    src={content?.gif_image}
                />
            )}
            {content?.gif_video && (
                <video
                    autoPlay
                    className={`t-805-video ${deviceType}`}
                    loop
                    playsInline
                    src={content?.gif_video}
                />
            )}
            <EditBlockSite
                isInComponent={isInComponent}
                mainParentId={mainParentId || object.id!}
                object={object}
                parentArray={parentArray}
                parentStyles={parentStyles}
            />
        </LinkHelperSite>
    )
})
